import { useEffect, useState } from "react";
import api from "@/lib/api";

let cache = null;
let pending = null;
const subs = new Set();

const load = () => {
  pending = api.get("/suppliers").then((r) => {
    cache = new Set(r.data.filter((s) => s.verified).flatMap((s) => [s.id, s.name]));
    subs.forEach((f) => f());
  }).catch(() => {});
  return pending;
};

export const refreshVerified = () => load();

export const VerifiedBadge = ({ className = "h-4 w-4" }) => (
  <img src="/verified.png" alt="Terverifikasi" title="Supplier terverifikasi" className={`inline-block shrink-0 align-[-2px] ${className}`} data-testid="verified-badge" />
);

export const SupplierName = ({ name, id, className = "" }) => {
  const [, tick] = useState(0);
  useEffect(() => {
    const f = () => tick((n) => n + 1);
    subs.add(f);
    if (!cache && !pending) load();
    return () => { subs.delete(f); };
  }, []);
  const ok = cache && (cache.has(id) || cache.has(name));
  return <span className={`inline-flex items-center gap-1 min-w-0 ${className}`}><span className="truncate">{name}</span>{ok && <VerifiedBadge />}</span>;
};
